import {useContext} from "react";
import { AppContext } from 'App';
import httpMethod from "../../services/update2025/httpMethod";
import { apiIDP } from "../../constant/apis/api";


export default function useGetProfile() {
    const { setLoading } = useContext(AppContext);

    const getProfile = async ({ onSuccess }) => {
        setLoading(true);
        try {
            const res = await httpMethod.get(`${process.env.REACT_APP_IDP_SSO_URL}${apiIDP.GET_PROFILE}`);
            if (res.status === 200) onSuccess(res.data);
        } finally {
            setLoading(false);
        }
    };

    return { getProfile };
}
